<template>
  <div>
    <button
      v-if="!loading"
      type="button"
      aria-label="Gebruik mijn locatie"
      class="w-6 h-6"
      @click="fillCity"
    >
      <LocationService />
    </button>

    <div
      v-else
      aria-label="Loading location"
      class="w-6 h-6 border-[3px] border-black/20 border-t-black/60 rounded-full animate-spin"
    />
  </div>
</template>

<script>
import LocationService from '@/components/svg/LocationService.vue';
import axios from 'axios';


export default {
  name: 'LocatorUserLocation',
  components: { LocationService },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    fillCity() {
      if (!navigator.geolocation) {
        console.error('Geolocation is not supported by this browser.');
        return;
      }
      this.loading = true;

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          const { latitude, longitude } = coords;

          // Reverse‑geocode via Nominatim
          axios
            .get('https://nominatim.openstreetmap.org/reverse', {
              params: {
                format: 'json',
                lat: latitude,
                lon: longitude,
                addressdetails: 1,
              },
            })
            .then(({ data }) => {
              const addr = data.address || {};
              // Prefer "city", then "town", "village", "hamlet"
              const city =
                addr.city ||
                addr.town ||
                addr.village ||
                addr.hamlet ||
                addr.county; // fallback if needed

              if (city) {
                // emit new v-model value
                this.$emit('input', city);
              } else {
                console.error('No city found in response.');
              }
            })
            .catch(err => console.error('Reverse geocode error:', err))
            .finally(() => {
              this.loading = false;
            });
        },
        error => {
          console.error('Geolocation error:', error);
          this.loading = false;
        }
      );
    },
  },
};
</script>
